import React from 'react';
import { connect } from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../../../constants/Languages.js';

//import img
import cardsImg from '../../../../assets/icons/cards.svg';

import event from '../../../../assets/icons/event.svg';
import eventSeries from '../../../../assets/icons/event-series.svg';
import work from '../../../../assets/icons/work.svg';
import journal from '../../../../assets/icons/journal.svg';
import journalNumber from '../../../../assets/icons/journal-number.svg';
import institution from '../../../../assets/icons/institution.svg';
import series from '../../../../assets/icons/series.svg';
import person from '../../../../assets/icons/person.svg';

//import components
import DownloadFormats from '../../../formats-to-download/DownloadFormats.js';


const PageHeaderCard = ({ clang, name, type }) => {
	const getImg = (type) => {
		switch (type) {
			case 'person':
				return person;
			case 'series':
				return series;
			case 'event-series':
				return eventSeries;
			case 'event':
				return event;
			case 'institution':
				return institution;
			case 'creative-work':
				return work;
			case 'journal':
				return journal;
			case 'journal-number':
				return journalNumber;
			default:
				return;
		}
	};
	return (
		<div className="card__page-header">
			<h3 className="card__main-header">
				{ type && <img src={ getImg(type) } alt={ lang[ clang ].alt.card } className="card__main-header__img" /> }
				{ !type && <img src={ cardsImg } alt={ lang[ clang ].alt.card } className="card__main-header__img" /> }
				{ name }
			</h3>
			<DownloadFormats lang={ lang }/>
		</div>
	);
};

PageHeaderCard.propTypes = {
	clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
	clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(PageHeaderCard);



// WEBPACK FOOTER //
// ./src/components/items/cards/common/PageHeaderCard.js